// src/components/proposals/LiveQuoteCalculator.tsx

import React from 'react';
import { Card } from '@dopomogai/ui';

// --- PROPS INTERFACE ---

type Props = {
  /** The sum of all selected feature prices. */
  totalCost: number;
  /** The total cost after the partner discount is applied. */
  partnerPrice: number;
  /** The sum of all selected feature ETAs in business days. */
  totalEta: number;
  /** Optional className for custom styling. */
  className?: string;
};

// --- HELPER FUNCTIONS ---

const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(amount);
};

// --- COMPONENT IMPLEMENTATION ---

/**
 * A display component that shows the running totals for the proposal quote.
 * It is designed to be placed in a sticky sidebar for constant visibility.
 */
export const LiveQuoteCalculator: React.FC<Props> = ({
  totalCost,
  partnerPrice,
  totalEta,
  className,
}) => {
  return (
    <Card className={className}>
      <div className="p-5">
        <h3 className="text-lg font-extrabold text-slate-900 mb-3">Live Quote</h3>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between items-center">
            <span className="text-slate-600">Total Setup Cost:</span>
            <span className="font-bold text-slate-800">{formatCurrency(totalCost)}</span>
          </div>
          
          <div className="flex justify-between items-center text-emerald-700 bg-emerald-50 -mx-2 px-2 py-1 rounded">
            <strong>Your Partner Price (11% off):</strong>
            <strong className="text-xl">{formatCurrency(partnerPrice)}</strong>
          </div>

          <hr className="my-2 border-slate-200" />
          
          <div className="flex justify-between items-center">
            <span className="text-slate-600">Est. Business Days:</span>
            <span className="font-bold text-slate-800">{totalEta}</span>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default LiveQuoteCalculator;